require('./brokerInterestModal.scss');
const { FormattedText } = require('core/i18n').i18n;

const OKModal = require('components/commons/OKModal/OKModal');

class BrokerInterestModal extends React.Component {
  buildModalBody() {
    return (
      <section className="broker-contribution-interest-modal__content">
        <section className={'broker-contribution-interest-modal__first-pharagraph'}>
          <FormattedText value="brokerContributionFundStep1-modalFirstPharagraph" />
        </section>
        <section>
          <div className={'broker-contribution-interest-modal__example-pharagraph'}>
            <FormattedText value="brokerContributionFundStep1-modalExamplePharagraph" />
          </div>
          <ol>
            <li>
              <FormattedText value="brokerContributionFundStep1-modalExampleItemUno" />
            </li>
            <li>
              <FormattedText value="brokerContributionFundStep1-modalExampleItemDos" />
            </li>
          </ol>
        </section>
      </section>
    );
  }

  render() {
    const modalContent = this.buildModalBody();

    return (
      <OKModal
        content={modalContent}
        isOpen={this.props.isOpen}
        onCloseCallback={this.props.onCloseCallback}
        title="brokerContributionFundStep1-modalInterestTitle"
        titleAlignment="center"
        size="regular"
        footerType="action"
        primaryButtonText={'Continuar'}
        onPrimaryButtonClick={this.props.onCloseCallback}
      />
    );
  }
}

module.exports = BrokerInterestModal;
